import { render, staticRenderFns } from "./TzjDialog.vue?vue&type=template&id=07d293ba&scoped=true"
import script from "./TzjDialog.vue?vue&type=script&lang=js"
export * from "./TzjDialog.vue?vue&type=script&lang=js"
import style0 from "./TzjDialog.vue?vue&type=style&index=0&id=07d293ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d293ba",
  null
  
)

export default component.exports